import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { CustomState } from "@ucs/Store/Reducers";

export function getNextAvailableTruckState(state: CustomState) {
    return state.customReducer.nextAvailableTruck;
}
export function getEditedNotes(state: ApplicationState) {
    return state.pages.checkoutShipping.editedCartNotes;
}
export function getDateTruckErrorState(state: CustomState) {
    return state.customReducer.dateTruckError;
}
export function getRequestedDeliveryDateState(state: CustomState) {
    return state.pages.checkoutReviewAndSubmit.requestedDeliveryDate;
}
export function getCurrentCountriesState(state: CustomState) {
    return state.customReducer.currentCountries;
}
export function getIsLoadingCurrentCountriesState(state: CustomState) {
    return state.customReducer.isLoadingCurrentCountries;
}
export function getPLPRendering(state: CustomState) {
    return state.customReducer.gridHeight;
}
export function getCurrentCurrentCustomerBillTosState(state: CustomState) {
    return state.customReducer.currentCustomerBillTos;
}
export function getIsLoadingCurrentCustomerBillTosState(state: CustomState) {
    return state.customReducer.isLoadingCurrentCustomerBillTos;
}
export function getCartPoNumberState(state: CustomState) {
    return state.customReducer.cartPoNumber;
}
export function getIsLocalSelectedPLPState(state: CustomState) {
    return state.customReducer.isLocalSelectedPLP;
}
export function getBreadcrumbFilterUrl(state: CustomState) {
    return state.customReducer.breadcrumbFilterUrl;
}
export function getCurrentPDPProductPath(state: CustomState) {
    return state.pages.productDetails.lastProductPath
}
export function getGeoPermission(state: CustomState) {
    return state.customReducer.isGeoPermissionDenied || "";
}
export function getDealersDropdown(state: CustomState) {
    return state.customReducer.dealersDropdown;
}